import React from "react";

export const About = () => {
  return (
    <div name="about" className="w-full h-screen bg-navbar text-gray-300">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-pink-600">
              About
            </p>
          </div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <p className="sm:text-right text-4xl font-bold">
            Hi. I'm Deepak, nice to meet you. Please take a look around
          </p>
          <p>
            I am passionate about building excellent frontend web applications.
            I specialize in creating responsive web applications ranging from
            individuals to small business.
          </p>
        </div>
      </div>
    </div>
  );
};
